<section class="section-pd">
    <div class="trinka_container">
        <div class="secure-wrapper">
            <div class="row align-items-center match-box">
                <div class="col-md-6 col-lg-7 dflex">
                    <div class="trinka-title mb-0">
                        <h2>你的寫作隱私由你做主</h2>
                        <div class="HeadingSubLine1"><span></span><span></span><span></span></div>
                        <p>透過我們的敏感資料保護方案，您的資料將受到嚴密保護，完全符合隱私與合規需求：</p>
                        <ul>
                            <li>不留存任何資料，確保即時清除</li>
                            <li>拒絕 AI 訓練</li>  
                            <li>讓你完全掌握資料權限</li>     
                        </ul>
                        <div class="btn-group">
                            <a href="/enterprise/sensitive-data-plan" class="filled-btn">了解更多</a>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-lg-5 dflex ">
                    <div class="text-center">
                        <!-- <picture>
                            <source srcset="../../../assets/images/homepage/data-security.webp" type="image/webp">
                            <img src="../../../assets/images/homepage/data-security.jpg" loading="lazy" decoding="async" alt="data-security">
                        </picture> -->
                        <img src="../../../assets/images/homepage/data-security.svg" class="img-fluid" loading="lazy" decoding="async" alt="data-security">
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>